import React from 'react';

import { useTranslation } from '@crehana/i18n';

import DiscountSummary from 'Jsx/CheckoutV4/components/DiscountSummary';

import {
  ProductItem,
  ShoppingCartItem,
  DegreeQuota,
} from 'Jsx/CheckoutV4/types';

import CoursesAndBundlesDetail from './ProductDetail/CoursesAndBundlesDetail';
import MembershipDetail from './ProductDetail/MembershipDetail';
import DegreeDetail from './ProductDetail/DegreeDetail';
import CourseDetail from './ProductDetail/CourseDetail';

const PurchaseDetail: React.FC<{
  checkoutProductDetail: ProductItem;
  productsList?: ShoppingCartItem[];
  selectedQuota?: DegreeQuota | null;
}> = ({ checkoutProductDetail, productsList, selectedQuota }) => {
  const { t } = useTranslation();
  const { title, membershipTag, codeSymbol, price, realPrice, type } =
    checkoutProductDetail;

  const customTitle =
    membershipTag === 'PREMIUM' ? 'Membresía Premium Individual' : title;
  const renderProductInfo = () => {
    switch (type) {
      case 'membership':
        return <MembershipDetail months={checkoutProductDetail?.months} />;
      case 'course':
        return <CourseDetail />;
      case 'custom_bundle':
      case 'bundle':
      case 'shopping_cart':
        return <CoursesAndBundlesDetail productsList={productsList} />;
      case 'degree':
        return <DegreeDetail />;
      default:
        return null;
    }
  };

  const showRealPrice = realPrice! > price!;
  const quotaPrice = selectedQuota?.newTotalLocal || price;

  return (
    <div>
      <h4 className="flex items-center justify-between font-h4">
        {customTitle}
      </h4>
      <div>{renderProductInfo()}</div>
      <DiscountSummary
        checkoutProductDetail={checkoutProductDetail}
        className="mt-12"
      />
      <div className="flex w-full mt-32">
        <div className="flex items-center w-full justify-between">
          <p className="mr-12 font-body2 ">{t('LONG_PAYMENT_TAG')}:</p>
          <p className="flex items-center">
            <span className="font-price text-red-main">
              <span data-testid="product-price-currency">{codeSymbol}</span>
              <span data-testid="product-price">
                {quotaPrice?.toLocaleString('en-US')}
              </span>
            </span>
            {showRealPrice && (
              <span className="line-through text-secondary-dark font-discount-s">
                {codeSymbol}
                {realPrice?.toLocaleString('en-US')}
              </span>
            )}
          </p>
        </div>
        {selectedQuota?.quotaNumber! > 1 && (
          <span className="font-subtitle3 mt-12 sm:mt-0 sm:ml-16">
            {`${
              selectedQuota?.quotaNumber
            } meses de ${codeSymbol} ${selectedQuota?.quotaAmount?.toLocaleString(
              'en-US',
            )}`}
          </span>
        )}
      </div>
    </div>
  );
};

export default PurchaseDetail;
